<template>
  <div class="banner flex row-between">
    <img
      :src="
        require('@/assets/images/supplier/guarantee-pre-save/network-notice-banner.png')
      "
      alt=""
      @click="toGuaranteePreSave"
    />
    <img
      :src="require('@/assets/images/value-added/network-notice-banner.png')"
      alt=""
      @click="toNetworkBusiness"
    />
  </div>
</template>

<script>
export default {
  name: 'NetworkNoticeBanner',

  methods: {
    toNetworkBusiness() {
      const url = process.env.VUE_APP_BIDDOG_URL + '/network-notice'
      window.open(url, '_blank')
    },

    toGuaranteePreSave() {
      const route = this.$router.resolve({
        name: 'GuaranteePreSaveOpen'
      })
      window.open(route.href, '_blank')
    }
  }
}
</script>

<style lang="scss" scoped>
.banner {
  img {
    width: calc((100% - 20px) / 2);
    cursor: pointer;
  }
}
</style>
